import { render } from "./PendingClearanceCertificates.vue?vue&type=template&id=2b580cc4&scoped=true"
import script from "./PendingClearanceCertificates.vue?vue&type=script&lang=js"
export * from "./PendingClearanceCertificates.vue?vue&type=script&lang=js"

import "./PendingClearanceCertificates.vue?vue&type=style&index=0&id=2b580cc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b580cc4"]])

export default __exports__